import CreationToolGradient from '../../../types/gradient'
import CreationToolRating from '../../../types/rating'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import SegmentedControl from '../../segmented-control'
import Instructions from './field-instructions'
import Title from './field-title'

type Props = {
    className?: string
    field: CreationToolUploadField
    defaultRating?: CreationToolRating
    gradient?: CreationToolGradient
    showInstructions?: boolean
    onChange: (rating: CreationToolRating) => void
}

const CreationRatingField = ({
    className,
    field,
    defaultRating = CreationToolRating.Unrated,
    gradient = CreationToolGradient.PurpleRed,
    showInstructions = false,
    onChange,
}: Props) => {
    const ratings = CreationToolRating.all()

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <SegmentedControl
                {...{
                    defaultIndex: ratings.indexOf(defaultRating),
                    gradient,
                    items: ratings.map(CreationToolRating.title),
                    onIndexChange: (index) => onChange(ratings[index]),
                }}
            />
            {showInstructions && <Instructions field={field} />}
        </UploadFieldBlock>
    )
}

export default CreationRatingField
